<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card color="primary" dark>
          <v-card-title>
            <v-text-field
              v-model="stationName"
              label="Station"
              prepend-icon="mdi-memory"
              required
              readonly
            ></v-text-field>
            
            <v-dialog
              ref="dialogDate"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Pick Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-if="modal"
                v-model="date"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="modal = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogDate.save(date);getData(station.value,tab,date,time,station.satuan,station.text);modal=false"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>

            

            <v-dialog
              ref="dialog"
              v-model="modal2"
              :return-value.sync="time"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="time"
                  label="Choose Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="modal2"
                v-model="time"
                full-width
                :allowed-minutes="allowedStep"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="modal2 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(time);getData(station.value,tab,date,time,station.satuan,station.text)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
            <download-csv
              class   = "btn btn-default"
              :data   = "fileDownload"
              :name    = "csvTitle"
              separator-excel
              :labels  = "labelsCSV">
              <v-btn class="float-start mb-2" color="white" text><v-icon center>mdi-download</v-icon></v-btn>
            </download-csv>
          </v-card-title>
             <v-tabs
              v-model="tab"
              background-color="primary"
              color="white"
              show-arrows
              grow
              @change="getData(station.value,tab,date,time,station.satuan,station.text)"
            >
              <v-tabs-slider color="#0897d7"></v-tabs-slider>
              <v-tab
                v-for="item in items"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">

              <!-- Daily -->
              <v-tab-item>
                <v-card flat class="text-center">
                  <Bar
                    class="d-none d-md-flex"
                    :chart-options="chartOptions"
                    :chart-data="chartDataDaily"
                    :height="200"
                  />
                  <Bar
                    class="d-flex d-md-none"
                    :chart-options="chartOptions"
                    :chart-data="chartDataDaily"
                    :height="350"
                  />
                </v-card>
              </v-tab-item>

              <!-- Monthly -->
              <v-tab-item>
                <v-card flat class="text-center">
                <Bar
                  class="d-none d-md-flex"
                  :chart-options="chartOptions"
                  :chart-data="chartDataMonthly"
                  :height="200"
                />
                <Bar
                  class="d-flex d-md-none"
                  :chart-options="chartOptions"
                  :chart-data="chartDataMonthly"
                  :height="350"
                />
                </v-card>
              </v-tab-item>

              <!-- Yearly -->
              <v-tab-item>
                <v-card flat class="text-center">
                <Bar
                  class="d-none d-md-flex"
                  :chart-options="chartOptions"
                  :chart-data="chartDataYearly"
                  :height="200"
                />
                <Bar
                  class="d-flex d-md-none"
                  :chart-options="chartOptions"
                  :chart-data="chartDataYearly"
                  :height="350"
                />
                </v-card>
              </v-tab-item>
            </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db }from "@/firebase/db.js"
import moment from 'moment'
import { Bar } from 'vue-chartjs/legacy'

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

import csvtojson from 'csvtojson'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default ({
  components: { Bar },
  data: () => ({
    modal:false,
    modal2:false,
    date:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    time:null,
    devices:[],
    data:[],
    offset:0,

    tab: null,
    items: [
      '2 Hours', '4 Hours', '24 Hours'
    ],
  
    dialog:false,
    ID:null,
    chartDataDaily: {
      labels: [],
      datasets: [ { label: 'Ketinggian (m)',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartDataMonthly: {
      labels: [],
      datasets: [ { label: 'Ketinggian (m)',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartDataYearly: {
      labels: [],
      datasets: [ { label: 'Ketinggian (m)',data: [],backgroundColor: '#3f51b5', minBarLength: 1 } ],
    },
    chartOptions: {
      responsive: true
    },
    headersDetail: [
      {
        text: 'Tanggal',
        align: 'start',
        value: 'tanggal',
      },
      { text: 'Curah (mm)', value: 'curah' },
    ],
    fileDatum:[],
    labels:[],
    datasets:[],
    location:null,
    locations:['WS CIMANUK - CISANGGARUNG', 'WS CITANDUY', 'WS CIWULAN - CILAKI','WS CISADEA - CIBARENO','WS CITARUM', 'WS CILIWUNG - CISADANE'],
    station: null,
    stations:[],
    csvTitle:null,
    labelsCSV:{
      Time: 'Time',
      Baterai: 'Baterai (V)',
      Charger: 'Charger',
      FullCharger: 'Full Charger',
      TinggiPermukaanAir: 'Tinggi Muka Air (m)'
    },
    fileDownload:[],
    enableLocation:true,
    stationName:null,
  }),
  async mounted() {
    const date=new Date();
    this.offset=date.getTimezoneOffset()/(-60)
    this.time=moment.unix(Date.now()/1000).utcOffset(this.offset).format("HH:mm")
    let loader = this.$loading.show()
    await db.collection('radar').doc(this.$route.params.mac).get().then((doc)=> {
      this.station={
        value: doc.id,
        text: doc.data().station,
        satuan: doc.data().satuan,
      }
    })
    this.stationName=this.station.text
    this.getData(this.station.value,this.tab,this.date,this.time,this.station.satuan,this.station.text)
    loader.hide()
  },
  watch: {
    date:function (val) {
      console.log(val)
    }
  },
  methods: {
    updateTime (time) {
      return moment.unix(time/1000).utcOffset(this.offset).format("HH:mm")
    },
    allowedStep: m => m % 60 === 0,
    async getData(station,tab,datePick,timePick,satuan,stationName) {
      if (station!=null) {
        if (tab==0) {
          let start = moment(datePick, "YYYY-MM-DD").valueOf()+parseInt(timePick.substr(0,2))*3600000+parseInt(timePick.substr(3,2))*60000+300000;
          let end = start-7200000;
          await db.collection('radar').doc(station).collection('data').orderBy("time","asc").where("time", ">=", end).where("time", "<=", start).get().then((collectionSnapshot) => {
            this.datasets =[]
            this.labels=[]
            this.fileDownload=[]
            collectionSnapshot.forEach((doc) => {
              csvtojson()
              .fromString(doc.data().data)
              .then((csvRow)=>{ 
                  this.fileDatum=csvRow
                  this.fileDatum.forEach((data) => {
                    this.labels.push(this.updateTime(moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf()))
                    this.datasets.push(satuan=='cm'?Math.round(data.TinggiPermukaanAir*100):data.TinggiPermukaanAir)
                    this.fileDownload.push({
                      Time:moment.unix((moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf())/1000).utcOffset(this.offset).format("DD/MM/YYYY HH:mm:ss"),
                      Baterai: data.Baterai,
                      Charger: data.Charger,
                      FullCharger: data.FullCharger,
                      TinggiPermukaanAir: satuan=='cm'?Math.round(data.TinggiPermukaanAir*100):data.TinggiPermukaanAir
                    })
                  })
                  this.labelsCSV.TinggiPermukaanAir=`Tinggi Permukaan Air (${satuan})`
                  this.csvTitle=`${this.location}_${stationName}_${datePick}_${timePick.substr(0,2)}-${timePick.substr(3,2)}_2Hours.csv`
                  this.modal=false
              })
            });
            this.chartDataDaily =  {
              labels: this.labels,
              datasets: [ { label: `Tinggi Permukaan Air (${satuan})`,data: this.datasets,backgroundColor: '#3f51b5', minBarLength: 1 } ],
            }
          })
        } else if (tab==1) {
          let start = moment(datePick, "YYYY-MM-DD").valueOf()+parseInt(timePick.substr(0,2))*3600000+parseInt(timePick.substr(3,2))*60000+300000;
          let end = start-14400000;
          await db.collection('radar').doc(station).collection('data').orderBy("time","asc").where("time", ">=", end).where("time", "<=", start).get().then((collectionSnapshot) => {
            this.datasets =[]
            this.labels=[]
            this.fileDownload=[]
            collectionSnapshot.forEach((doc) => {
              csvtojson()
              .fromString(doc.data().data)
              .then((csvRow)=>{ 
                  this.fileDatum=csvRow
                  this.fileDatum.forEach((data) => {
                    this.labels.push(this.updateTime(moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf()))
                    this.datasets.push(satuan=='cm'?Math.round(data.TinggiPermukaanAir*100):data.TinggiPermukaanAir)
                    this.fileDownload.push({                      
                      Time:moment.unix((moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf())/1000).utcOffset(this.offset).format("DD/MM/YYYY HH:mm:ss"),
                      Baterai: data.Baterai,
                      Charger: data.Charger,
                      FullCharger: data.FullCharger,
                      TinggiPermukaanAir: satuan=='cm'?Math.round(data.TinggiPermukaanAir*100):data.TinggiPermukaanAir
                    })
                  })
                  this.csvTitle=`${this.location}_${stationName}_${datePick}_${timePick.substr(0,2)}-${timePick.substr(3,2)}_4Hours.csv`
                  this.modal=false
              })
            });
            this.chartDataMonthly =  {
              labels: this.labels,
              datasets: [ { label: `Tinggi Permukaan Air (${satuan})`,data: this.datasets,backgroundColor: '#3f51b5', minBarLength: 1 } ],
            }
          })
        } else if (tab==2) {
          let start = moment(datePick, "YYYY-MM-DD").valueOf()+parseInt(timePick.substr(0,2))*3600000+parseInt(timePick.substr(3,2))*60000+300000;
          let end = start-86400000;
          await db.collection('radar').doc(station).collection('data').orderBy("time","asc").where("time", ">=", end).where("time", "<=", start).get().then((collectionSnapshot) => {
            this.datasets =[]
            this.labels=[]
            this.fileDownload=[]
            collectionSnapshot.forEach((doc) => {
              csvtojson()
              .fromString(doc.data().data)
              .then((csvRow)=>{ 
                  this.fileDatum=csvRow
                  this.fileDatum.forEach((data) => {
                    this.labels.push(this.updateTime(moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf()))
                    this.datasets.push(satuan=='cm'?Math.round(data.TinggiPermukaanAir*100):data.TinggiPermukaanAir)
                    this.fileDownload.push({
                      Time:moment.unix((moment(data.Time, "DD/MM/YYYY/HH:mm:ss").valueOf())/1000).utcOffset(this.offset).format("DD/MM/YYYY HH:mm:ss"),
                      Baterai: data.Baterai,
                      Charger: data.Charger,
                      FullCharger: data.FullCharger,
                      TinggiPermukaanAir: satuan=='cm'?Math.round(data.TinggiPermukaanAir*100):data.TinggiPermukaanAir
                    })
                  })
                  this.csvTitle=`${this.location}_${stationName}_${datePick}_${timePick.substr(0,2)}-${timePick.substr(3,2)}_24Hours.csv`
                  this.modal=false
              })
            });
            this.chartDataYearly =  {
              labels: this.labels,
              datasets: [ { label: `Tinggi Permukaan Air (${satuan})`,data: this.datasets,backgroundColor: '#3f51b5', minBarLength: 1 } ],
            }
          })
        }
      }
      
    },
  }
})
</script>

